import { createTransport } from './transport.js';
import { createPasskeysNamespace } from './passkeys/index.js';
export function createAuthClient(config) {
    const request = createTransport({
        baseUrl: config.baseUrl,
        fetch: config.fetch ?? fetch.bind(globalThis),
        getAccessToken: config.getAccessToken,
        refreshAccessToken: config.refreshAccessToken,
    });
    return {
        passkeys: createPasskeysNamespace(request, config.appId),
    };
}
